import Modal from "../base/Modal";
import Icon from "../base/Icon";


function ModalLimited() {

    return (
        <Modal id="modal-user-is-limited"
            title="Account Restricted"
            buttonText="Subscribe Now"
            buttonColor="primary"
            cancelText="Close"
            onConfirm={callback => {
                document.location.href = "/system/finance/subscription";
            }}>
            <div className="text-center py-8">
                <Icon icon="lock" size={44} className="text-danger mb-5" />
                <p className="text-danger fs-5 mb-0">
                    This account has been restricted.
                </p>
                <p className="text-gray-700 mt-2">
                    Please renew your subscription to continue.
                </p>
            </div>
        </Modal>
    )
}

export default ModalLimited;